import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  NgClass,
  NgForOf,
  NgIf,
  NgOptimizedImage,
  UpperCasePipe,
} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '../components/button/button.component';
import { ToastWrapperComponent } from '../components/toast-wrapper/toast-wrapper.component';
import { ThemeService } from '../../helper-service/theme-service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    UpperCasePipe,
    NgForOf,
    NgOptimizedImage,
    TranslatePipe,
    NgIf,
    FormsModule,
    ButtonComponent,
    NgClass,
    ToastWrapperComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent extends ThemeService implements OnInit {
  languages = ['en', 'de', 'ig'];
  currentLang = 'en';
  currentFlagIcon = `${this.currentLang}.svg`;
  isMobileMenuOpen = false;
  activeHeaderNav = '';
  enableBanner: boolean = true;

  private languageLabel = 'locale';

  constructor(private translate: TranslateService, private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.translate.addLangs(this.languages);
    const savedLang = localStorage.getItem(this.languageLabel);
    const browserLang = this.translate.getBrowserLang();
    const lang: string = savedLang
      ? savedLang
      : browserLang && this.languages.includes(browserLang)
      ? browserLang
      : 'en';
    this.currentLang = lang;
    this.currentFlagIcon = `${lang}.svg`;
    this.translate.use(lang);
    localStorage.setItem(this.languageLabel, lang);
    this.activeHeaderNav = window.location.pathname.split('/')[1];
  }

  switchLanguage(lang: string): void {
    this.translate.use(lang);
    this.currentLang = lang;
    this.currentFlagIcon = `${lang}.svg`;
    localStorage.setItem(this.languageLabel, lang);
  }

  navigateTo(path: string) {
    if (path === '/') {
      this.activeHeaderNav = '';
    }

    this.router.navigate([path]).then((r) => this.toggleMobileMenu()); // fast client-side navigation
  }

  navigateWithParams(path: string, id: number) {
    this.router.navigate([path], { queryParams: { id } }).then();
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  toggleIsMobile = (): boolean => {
    const maxWidth: number = 768;
    if (typeof window === 'undefined') {
      return false;
    }
    return window.innerWidth <= maxWidth;
  };

  setActiveHeaderNav = (path: string): void => {
    this.isMobileMenuOpen = false;
    this.activeHeaderNav = path;
  };
}
